
import { useState } from 'react';
import Button from '../../components/base/Button';

function isPastDateDot(dateDot: string) {
  const m = /^(\d{4})\.(\d{2})\.(\d{2})$/.exec(dateDot);
  if (!m) return false;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  const showDate = new Date(y, mo - 1, d, 23, 59, 59, 999);
  return Date.now() > showDate.getTime();
}

export default function LivePage() {
  const [selectedYear, setSelectedYear] = useState('2024');

  const liveShows = {
    '2024': [
      {
        id: 1,
        date: '2024.04.15',
        venue: '渋谷クラブクアトロ',
        city: '東京',
        time: '19:00 開演 / 18:30 開場',
        status: 'チケット販売中',
        price: '前売り ¥4,500 / 当日 ¥5,000',
        description: '春のアコースティックツアー第1弾。新曲「桜の記憶」を初披露予定です。',
        ticketUrl: '#',
        image: 'https://readdy.ai/api/search-image?query=intimate%20acoustic%20concert%20venue%20with%20warm%20lighting%2C%20cozy%20atmosphere%2C%20small%20stage%20with%20guitar%20and%20microphone%2C%20wooden%20interior%2C%20soft%20ambient%20lighting%2C%20music%20venue%20setting&width=400&height=300&seq=live1&orientation=landscape'
      },
      {
        id: 2,
        date: '2024.04.22',
        venue: '大阪ブルーノート',
        city: '大阪',
        time: '18:30 開演 / 18:00 開場',
        status: 'チケット販売中',
        price: '前売り ¥4,500 / 当日 ¥5,000',
        description: 'ジャズクラブでの特別なアコースティックライブ。大人の雰囲気の中でお楽しみください。',
        ticketUrl: '#',
        image: 'https://readdy.ai/api/search-image?query=elegant%20jazz%20club%20interior%20with%20dim%20lighting%2C%20sophisticated%20atmosphere%2C%20piano%20and%20acoustic%20guitar%20setup%2C%20intimate%20seating%20arrangement%2C%20warm%20amber%20lighting%2C%20classy%20music%20venue&width=400&height=300&seq=live2&orientation=landscape'
      },
      {
        id: 3,
        date: '2024.04.29',
        venue: '名古屋ブルーノート',
        city: '名古屋',
        time: '19:00 開演 / 18:30 開場',
        status: 'チケット販売中',
        price: '前売り ¥4,500 / 当日 ¥5,000',
        description: 'ゴールデンウィーク特別公演。リクエスト曲も演奏予定です。',
        ticketUrl: '#',
        image: 'https://readdy.ai/api/search-image?query=modern%20music%20venue%20with%20acoustic%20setup%2C%20warm%20stage%20lighting%2C%20intimate%20concert%20hall%20atmosphere%2C%20acoustic%20guitar%20and%20microphone%20on%20stage%2C%20comfortable%20seating%2C%20professional%20lighting&width=400&height=300&seq=live3&orientation=landscape'
      },
      {
        id: 4,
        date: '2024.05.12',
        venue: '横浜赤レンガ倉庫',
        city: '横浜',
        time: '17:00 開演 / 16:30 開場',
        status: '近日発売',
        price: '前売り ¥5,000 / 当日 ¥5,500',
        description: '歴史ある赤レンガ倉庫での野外ライブ。夕日とともにお楽しみください。',
        ticketUrl: '#',
        image: 'https://readdy.ai/api/search-image?query=outdoor%20concert%20venue%20at%20historic%20brick%20warehouse%2C%20sunset%20lighting%2C%20acoustic%20stage%20setup%20with%20beautiful%20architecture%20background%2C%20romantic%20evening%20atmosphere%2C%20warm%20golden%20hour%20lighting&width=400&height=300&seq=live4&orientation=landscape'
      },
      {
        id: 5,
        date: '2024.06.08',
        venue: '福岡サンパレス',
        city: '福岡',
        time: '19:00 開演 / 18:30 開場',
        status: '近日発売',
        price: '前売り ¥4,800 / 当日 ¥5,300',
        description: '九州ツアー開催決定！地元の皆様との再会を楽しみにしています。',
        ticketUrl: '#',
        image: 'https://readdy.ai/api/search-image?query=large%20concert%20hall%20with%20acoustic%20setup%2C%20professional%20stage%20lighting%2C%20elegant%20venue%20interior%2C%20acoustic%20guitar%20performance%20setup%2C%20warm%20atmospheric%20lighting%2C%20spacious%20audience%20seating&width=400&height=300&seq=live5&orientation=landscape'
      },
      {
        id: 6,
        date: '2024.07.20',
        venue: '札幌芸術の森',
        city: '札幌',
        time: '18:00 開演 / 17:30 開場',
        status: '近日発売',
        price: '前売り ¥5,200 / 当日 ¥5,700',
        description: '夏の北海道での特別野外ライブ。自然に囲まれた最高のロケーションです。',
        ticketUrl: '#',
        image: 'https://readdy.ai/api/search-image?query=outdoor%20forest%20concert%20venue%20surrounded%20by%20nature%2C%20acoustic%20stage%20setup%20in%20natural%20setting%2C%20summer%20evening%20atmosphere%2C%20trees%20and%20greenery%20background%2C%20peaceful%20outdoor%20music%20venue&width=400&height=300&seq=live6&orientation=landscape'
      }
    ],
    '2023': [
      {
        id: 7,
        date: '2023.12.24',
        venue: '東京国際フォーラム',
        city: '東京',
        time: '19:00 開演 / 18:30 開場',
        status: '終了',
        price: '前売り ¥6,000 / 当日 ¥6,500',
        description: 'クリスマスイブ特別公演。忘れられない一夜となりました。',
        ticketUrl: '#',
        image: 'https://readdy.ai/api/search-image?query=grand%20concert%20hall%20with%20Christmas%20decorations%2C%20elegant%20stage%20setup%20with%20acoustic%20instruments%2C%20festive%20lighting%2C%20sophisticated%20venue%20interior%2C%20holiday%20atmosphere%2C%20warm%20golden%20lighting&width=400&height=300&seq=live7&orientation=landscape'
      },
      {
        id: 8,
        date: '2023.11.15',
        venue: '大阪城ホール',
        city: '大阪',
        time: '18:30 開演 / 18:00 開場',
        status: '終了',
        price: '前売り ¥5,500 / 当日 ¥6,000',
        description: '秋のツアーファイナル。多くの感動をありがとうございました。',
        ticketUrl: '#',
        image: 'https://readdy.ai/api/search-image?query=large%20arena%20concert%20venue%20with%20acoustic%20setup%2C%20professional%20stage%20lighting%2C%20autumn%20themed%20decorations%2C%20spacious%20hall%20interior%2C%20warm%20atmospheric%20lighting%2C%20acoustic%20performance%20stage&width=400&height=300&seq=live8&orientation=landscape'
      }
    ]
  };

  const years = ['2024', '2023'];
  const currentShows = liveShows[selectedYear as keyof typeof liveShows] || [];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-gray-900 to-gray-700 text-white">
        <div className="absolute inset-0 bg-black/30"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=concert%20stage%20with%20acoustic%20guitar%20and%20microphone%20under%20dramatic%20stage%20lighting%2C%20empty%20venue%20before%20show%2C%20atmospheric%20lighting%2C%20professional%20music%20venue%20setup%2C%20warm%20stage%20lights&width=1200&height=600&seq=livehero&orientation=landscape')`
          }}
        ></div>
        <div className="relative container mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Live Information</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            心に響く音楽を生でお届けします。各地でのライブ情報をご確認ください。
          </p>
        </div>
      </section>

      {/* Year Filter */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="flex justify-center">
            <div className="flex bg-white rounded-full p-1 shadow-md">
              {years.map((year) => (
                <button
                  key={year}
                  onClick={() => setSelectedYear(year)}
                  className={`px-6 py-2 rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    selectedYear === year
                      ? 'bg-black text-white'
                      : 'text-gray-600 hover:text-black'
                  }`}
                >
                  {year}年
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Live Shows */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {currentShows.map((show) => (
                <div key={show.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                  <div className="relative h-48">
                    <img 
                      src={show.image} 
                      alt={show.venue}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-4 right-4">
                      <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                        show.status === 'チケット販売中' 
                          ? 'bg-green-100 text-green-800'
                          : show.status === '近日発売'
                          ? 'bg-blue-100 text-blue-800'
                          : 'bg-gray-100 text-gray-800'
                      }`}>
                        {show.status}
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-6">
                    <div className="flex items-start justify-between mb-4">
                      <div>
                        <div className="text-2xl font-bold text-black mb-1">
                          {show.date.split('.')[1]}.{show.date.split('.')[2]}
                        </div>
                        <div className="text-sm text-gray-500">
                          {show.date.split('.')[0]}
                        </div>
                      </div>
                      <div className="text-right">
                        <h3 className="text-xl font-bold mb-1">{show.venue}</h3>
                        <div className="flex items-center text-gray-600">
                          <i className="ri-map-pin-line mr-1"></i>
                          {show.city}
                        </div>
                      </div>
                    </div>

                    <p className="text-gray-600 mb-4 leading-relaxed">
                      {show.description}
                    </p>

                    <div className="space-y-2 mb-6">
                      <div className="flex items-center text-gray-600">
                        <i className="ri-time-line mr-2"></i>
                        {show.time}
                      </div>
                      <div className="flex items-center text-gray-600">
                        <i className="ri-ticket-line mr-2"></i>
                        {show.price}
                      </div>
                    </div>

                    {show.status !== '終了' && (
                      <Button 
                        className="w-full"
                        disabled={show.status === '近日発売' || isPastDateDot(show.date)}
                      >
                        <i className="ri-ticket-2-line mr-2"></i>
                        {show.status === '近日発売' ? '近日発売' : 'チケット購入'}
                      </Button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {currentShows.length === 0 && (
              <div className="text-center py-16">
                <i className="ri-calendar-line text-6xl text-gray-300 mb-4"></i>
                <h3 className="text-2xl font-bold text-gray-600 mb-2">
                  {selectedYear}年のライブ情報はありません
                </h3>
                <p className="text-gray-500">
                  新しいライブ情報が決まり次第、こちらでお知らせいたします。
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-4">ライブ情報をいち早くお届け</h2>
            <p className="text-gray-600 mb-8">
              新しいライブ情報やチケット先行販売の案内をお知らせします。
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Email Newsletter */}
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <div className="flex items-center justify-center w-16 h-16 bg-black rounded-full mx-auto mb-4">
                  <i className="ri-mail-line text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-3">メール配信</h3>
                <p className="text-gray-600 mb-6 text-sm">
                  ライブ情報やチケット先行販売をメールでお知らせ
                </p>
                <div className="flex flex-col gap-3">
                  <input
                    type="email"
                    placeholder="メールアドレスを入力"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black text-sm"
                  />
                  <Button className="w-full whitespace-nowrap">
                    <i className="ri-mail-line mr-2"></i>
                    登録する
                  </Button>
                </div>
              </div>

              {/* LINE Friend Registration */}
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <div className="flex items-center justify-center w-16 h-16 bg-green-500 rounded-full mx-auto mb-4">
                  <i className="ri-line-fill text-white text-2xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-3">LINE公式アカウント</h3>
                <p className="text-gray-600 mb-6 text-sm">
                  LINEでライブ情報や限定コンテンツをお届け
                </p>
                <a 
                  href="https://line.me/R/ti/p/@artist" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block w-full bg-green-500 hover:bg-green-600 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-300 cursor-pointer"
                >
                  <i className="ri-user-add-line mr-2"></i>
                  友だち追加
                </a>
                <div className="mt-4 p-3 bg-green-50 rounded-lg">
                  <p className="text-green-700 text-xs">
                    <i className="ri-gift-line mr-1"></i>
                    友だち登録で限定壁紙プレゼント！
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 text-center">
              <p className="text-gray-500 text-sm">
                どちらか一つでも、両方でも登録可能です。お好みの方法でライブ情報をお受け取りください。
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
